/* global Waypoint */
// import gsap from 'gsap';
import 'waypoints/lib/noframework.waypoints.min';
import './lib/foundation-explicit-pieces';
import './components/_blobs';

new Waypoint({
  element: document.querySelector('.footer'),
  handler: () => {
    document.querySelector('.blobs').classList.toggle('black');
    document.querySelector('.footer').classList.toggle('black');
  },
  offset: '60%',
});

// const rnd = (min, max) => Math.random() * (max - min) + min;

// const colors = ['rgba(255, 255, 255, 0.5)', 'rgba(0, 0, 0, 0.12)'];

// const boxes = document.querySelectorAll('.hero_circle');

// boxes.forEach((box) => {
// gsap.to('.hero_circle', {
//   backgroundColor: 'rgba(0, 0, 0, 0.12)',
//   // duration: rnd(2, 4),
//   // delay: rnd(0, 2),
//   duration: 2,
//   // delay: 1.5,
//   repeatDelay: 1.5,
//   repeat: -1,
//   yoyo: true,
//   ease: 'none',
// });
// // });

// for (i = 0; i < boxes.length; i++) {
//   gsap.from(boxes[i], randomNumber(1, 3), {
//     opacity: 0,
//     yoyo: true,
//     delay: randomNumber(0.5, 1.5),
//     repeat: -1,
//     ease: Linear.easeNone,
//   });

// }

// function randomNumber(min, max) {
//   return Math.random() * (max - min) + min;
// }

// set the initial color immediately.
// gsap.set('.hero_circle', { backgroundColor: colors[0] });
// now move the first color to the LAST position in the Array so that when it repeats, there's a smooth transition.
// colors.push(colors.shift());
